package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.DevicesW500Rounded: ImageVector
    get() {
        if (_devicesW500Rounded != null) {
            return _devicesW500Rounded!!
        }
        _devicesW500Rounded = Builder(name = "DevicesW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(475.7f, 414.5f)
                close()
                moveTo(430.2f, 808.13f)
                lineTo(117.37f, 808.13f)
                quadToRelative(-19.15f, 0.0f, -32.33f, -13.17f)
                quadToRelative(-13.17f, -13.18f, -13.17f, -32.33f)
                reflectiveQuadToRelative(13.17f, -32.33f)
                quadToRelative(13.18f, -13.17f, 32.33f, -13.17f)
                lineTo(430.2f, 717.13f)
                quadToRelative(19.15f, 0.0f, 32.32f, 13.17f)
                quadToRelative(13.18f, 13.18f, 13.18f, 32.33f)
                reflectiveQuadToRelative(-13.18f, 32.33f)
                quadToRelative(-13.17f, 13.17f, -32.32f, 13.17f)
                close()
                moveTo(202.39f, 677.13f)
                quadToRelative(-37.78f, 0.0f, -64.39f, -26.61f)
                reflectiveQuadToRelative(-26.61f, -64.39f)
                verticalLineToRelative(-343.26f)
                quadToRelative(0.0f, -37.78f, 26.61f, -64.39f)
                reflectiveQuadToRelative(64.39f, -26.61f)
                horizontalLineToRelative(600.48f)
                quadToRelative(19.15f, 0.0f, 32.33f, 13.17f)
                quadToRelative(13.17f, 13.18f, 13.17f, 32.33f)
                reflectiveQuadTo(835.2f, 229.7f)
                quadToRelative(-13.18f, 13.17f, -32.33f, 13.17f)
                lineTo(202.39f, 242.87f)
                verticalLineToRelative(343.26f)
                lineTo(430.2f, 586.13f)
                quadToRelative(19.15f, 0.0f, 32.32f, 13.17f)
                quadToRelative(13.18f, 13.18f, 13.18f, 32.33f)
                reflectiveQuadToRelative(-13.18f, 32.33f)
                quadToRelative(-13.17f, 13.17f, -32.32f, 13.17f)
                lineTo(202.39f, 677.13f)
                close()
                moveTo(801.91f, 721.91f)
                verticalLineToRelative(-312.82f)
                horizontalLineToRelative(-160.0f)
                verticalLineToRelative(312.82f)
                horizontalLineToRelative(160.0f)
                close()
                moveTo(624.07f, 808.13f)
                quadToRelative(-28.35f, 0.0f, -48.36f, -20.01f)
                quadToRelative(-20.01f, -20.01f, -20.01f, -48.36f)
                lineTo(555.7f, 391.0f)
                quadToRelative(0.0f, -28.59f, 20.01f, -48.36f)
                reflectiveQuadToRelative(48.36f, -19.77f)
                lineTo(820.0f, 322.87f)
                quadToRelative(28.59f, 0.0f, 48.36f, 19.77f)
                reflectiveQuadTo(888.13f, 391.0f)
                verticalLineToRelative(348.76f)
                quadToRelative(0.0f, 28.35f, -19.77f, 48.36f)
                quadToRelative(-19.77f, 20.01f, -48.36f, 20.01f)
                lineTo(624.07f, 808.13f)
                close()
                moveTo(721.91f, 513.87f)
                quadToRelative(14.04f, 0.0f, 23.22f, -9.6f)
                quadToRelative(9.17f, -9.6f, 9.17f, -22.79f)
                quadToRelative(0.0f, -14.04f, -9.17f, -23.22f)
                quadToRelative(-9.18f, -9.17f, -23.22f, -9.17f)
                quadToRelative(-13.19f, 0.0f, -22.79f, 9.17f)
                quadToRelative(-9.6f, 9.18f, -9.6f, 23.22f)
                quadToRelative(0.0f, 13.19f, 9.6f, 22.79f)
                reflectiveQuadToRelative(22.79f, 9.6f)
                close()
                moveTo(721.91f, 565.5f)
                close()
            }
        }
        .build()
        return _devicesW500Rounded!!
    }

private var _devicesW500Rounded: ImageVector? = null
